import { AxiosError } from "axios";
import { toast } from "react-toastify";

export function showErrorToast(message: string) {
  toast.error(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    progress: undefined,
    theme: "dark"
  });
}

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour12: true,
    hour: "2-digit",
    minute: "2-digit"
  };

  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
  return formattedDate.replace(",", "");
};

export const getPageKey = (landingPage : string | undefined) => {
  let pageKey = "1";

  switch (landingPage) {
    case "QCHold":
      pageKey = "2";
      break;
    case "SearchAdvanced":
      pageKey = "3";
      break;
  }

  return pageKey;
};

export const getAxiosErrorMessage = (error: AxiosError | string) => {
  if (typeof error === "string") {
    return error;
  }
  if (error.response) {
    return `Status:${error.response.status}\rMessage:${error.response.data}`;
  } else if (error.message) {
    return `Error: ${error.message}`;
  }
  return "Unknown error";
};
